import { render } from "./BeersKikirpa.vue?vue&type=template&id=015aeca8&scoped=true"
import script from "./BeersKikirpa.vue?vue&type=script&lang=js"
export * from "./BeersKikirpa.vue?vue&type=script&lang=js"

import "./BeersKikirpa.vue?vue&type=style&index=0&id=015aeca8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015aeca8"]])

export default __exports__